import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    day: 'Day 1',
    title: 'The Flush',
    description: 'Use the Osmotic Ratio to signal your body to release stored water and clear the inflammatory fog.'
  }, {
    day: 'Day 2',
    title: 'The Flatten',
    description: 'Implement the "Carb Curfew" and lymphatic massage to collapse the gas bubble in your lower abdomen.'
  }, {
    day: 'Day 3',
    title: 'The Seal',
    description: 'Use the "Dry Flush" and Posture Hack to tighten the abdominal wall for the perfect visual finish.'
  }];
  return <section className="py-16 px-6 max-w-3xl mx-auto" data-id="element-59">
      <FadeIn data-id="element-60">
        <h3 className="text-sm font-sans font-bold tracking-widest text-terracotta uppercase mb-4 text-center" data-id="element-61">
          The Blueprint
        </h3>
        <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-12 text-center leading-tight" data-id="element-62">
          How It Works
        </h2>

        <div className="relative border-l border-sage/30 ml-4 md:ml-8 space-y-12 pb-4" data-id="element-63">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-64">
              <div className="relative pl-8 md:pl-12" data-id="element-65">
                <div className="absolute -left-4 md:-left-4 top-0 w-8 h-8 rounded-full bg-sage text-cream flex items-center justify-center font-sans font-bold text-sm shadow-sm ring-4 ring-cream" data-id="element-66">
                  {index + 1}
                </div>
                <div className="bg-white p-6 rounded-xl shadow-sm border border-cream-dark" data-id="element-67">
                  <span className="text-sm font-sans font-bold text-sage mb-1 block uppercase tracking-wider" data-id="element-68">
                    {step.day}
                  </span>
                  <h4 className="font-serif text-2xl text-charcoal mb-3" data-id="element-69">
                    {step.title}
                  </h4>
                  <p className="text-charcoal-light font-sans leading-relaxed" data-id="element-70">
                    {step.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </section>;
}